import axios from 'axios';

/**
 * Public Venue Portal API client — uses shared password (X-Venue-Password header).
 * The password is stored in localStorage under 'venue_pw' after the gate accepts it.
 */
const venueApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/venue`,
});

venueApi.interceptors.request.use((config) => {
  const pw = localStorage.getItem('venue_pw');
  if (pw) config.headers['X-Venue-Password'] = pw;
  return config;
});

venueApi.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('venue_pw');
      if (window.location.pathname.startsWith('/venue')) {
        window.location.href = '/venue';
      }
    }
    return Promise.reject(error);
  }
);

export default venueApi;
